import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

type PageLinksState = Readonly<{
    allPages: any;
}>;

const initialState: PageLinksState = {
    allPages: null
};

const reducer = {
    "Custom/PageLinks/SetPages": (draft: Draft<PageLinksState>, action: { allPages: any }) => {
        draft.allPages = action.allPages;
    }
};
export default createTypedReducerWithImmer(initialState, reducer);
